import React from 'react';
import Imatge from 'components/corporatiu/Imatge';
// @ts-ignore
import BotoComponent from 'components/corporatiu/Boto';
const Boto: any = BotoComponent;
// @ts-ignore
import EnllacComponent from 'components/corporatiu/Enllac/Enllac';
import styles from './reptespersonals.module.scss';

const Enllac = EnllacComponent as React.ComponentType<{
    href?: string;
    title?: string;
    novaFinestra?: boolean;
    className?: string;
    children: React.ReactNode;
}>;

const IMG_BASE = 'https://statics.3cat.cat/recursos/marato/img';
const PDF_URL = 'https://statics.3cat.cat/multimedia/pdf/3/1/1751518967313.pdf';
const REPTES_URL = 'https://www.reptesperlamarato.cat';

interface InspiraTarjeta {
    imatge: string;
    imatgeAlt: string;
    titol: string;
    text: string;
}

const INSPIRA_CARDS: InspiraTarjeta[] = [
    {
        imatge: `${IMG_BASE}/icn-celebracio-RP.png`,
        imatgeAlt: 'imatge celebració',
        titol: 'Celebració',
        text: 'Celebres el teu aniversari, o el de noces, i en lloc de regals vols recollir donatius solidaris? Sou una família emprenedora i implicada en diverses causes i voleu recaptar per a La Marató?'
    },
    {
        imatge: `${IMG_BASE}/icn-esport-RP.png`,
        imatgeAlt: 'imatge esport',
        titol: 'Esport',
        text: "T'apuntaràs a una prova esportiva i hi vols afegir una motivació solidària? La Pica d'Estats, el Pedraforca, el Canigó o la Mola es poden convertir en el teu repte! O ets més de cursa ciclista, de bombers, de marató o de travessa nedant?"
    },
    {
        imatge: `${IMG_BASE}/icn-amics-RP.png`,
        imatgeAlt: 'imatge de grup',
        titol: 'Amics i família',
        text: 'Tens molts amics solidaris i també poder de convicció? Al teu voltant hi ha empreses solidàries amb ganes de fer donatius? Vius o has viscut de prop un problema de salut? Les xarxes són el teu medi natural? Ets un ambaixador potencial?'
    }
];

export default function ReptesPersonals() {
    return (
        <div className={styles.reptesPersonals}>
            <p className={styles.intro}>
                Si no formes part de cap entitat sense ànim de lucre i vols liderar una iniciativa per recollir donatius per a La
                Marató de 3Cat, tant si és individualment com en grup, pots fer un repte solidari durant tot l&apos;any!
            </p>

            <div className={styles.creaRepte}>
                <div>
                    <p className={styles.creaText}>Crea el teu repte ara amb</p>
                    <Enllac href={REPTES_URL} title='Crea el teu repte a reptesperlamarato.cat' novaFinestra={true}>
                        <Imatge
                            src={`${IMG_BASE}/2020/logo-migranodearena.png`}
                            alt='logo Migranodearena.org'
                            width={195}
                            height={118}
                        />
                    </Enllac>
                </div>

                <div>
                    <Boto link={PDF_URL} text="T'expliquem com fer-ho" novaFinestra={true} estil='marato' />
                </div>
            </div>

            <h2 className={styles.inspiraTitol}>Inspira&apos;t....</h2>

            <div className={styles.inspiraCards}>
                {INSPIRA_CARDS.map((card) => (
                    <div key={card.titol} className={styles.card}>
                        <div className={styles.cardImatge}>
                            <Imatge src={card.imatge} alt={card.imatgeAlt} width={110} height={60} />
                        </div>
                        <p className={styles.cardTitol}>{card.titol}</p>
                        <p className={styles.cardText}>{card.text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
